<template>
  <v-app-bar app color="#76008d" dark>
    <v-app-bar-nav-icon
      class="hidden-md-and-up"
      @click="$emit('handleDrawer')"
    />
    <div class="d-flex align-center">
      <v-list-item-avatar>
        <v-img
          src="https://png.pngtree.com/png-vector/20210615/ourlarge/pngtree-fifa-world-cup-golden-trophy-champion-league-png-image_3452588.jpg"
          alt="Coupe du monde"
          height="40px"
          width="40px"
          transition="scale-transition"
        />
      </v-list-item-avatar>
    </div>

    <v-spacer></v-spacer>

    <div class="links hidden-sm-and-down">
      <v-btn
        class="mr-2"
        v-for="(item, i) in items"
        :key="i"
        :to="item.to"
        text
      >
        <span class="shrink mr-2 hidden-sm-and-down">{{ item.text }}</span>
        <v-icon>{{ item.icon }}</v-icon>
      </v-btn>
    </div>

    <v-spacer></v-spacer>

    <v-btn href="https://github.com/ccbobs13" target="_blank" text>
      <span class="mr-2 hidden-md-and-down">Mon Github</span>
      <v-icon>mdi-github</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name: "HeaderComponent",
  created() {},
  data() {
    return {
      items: [
        {
          text: "Accueil",
          icon: "mdi-home",
          to: "/",
        },
        {
          text: "Confrontations",
          icon: "mdi-tournament",
          to: "/confrontation",
        },
        {
          text: "Coupes",
          icon: "mdi-trophy",
          to: "/coupe",
        },
        {
          text: "Pays",
          icon: "mdi-flag",
          to: "/pays",
        },
        {
          text: "Statistiques",
          icon: "mdi-chart-bar",
          to: "/statistiques",
        },

        // {
        //   text: "Tours",
        //   icon: "mdi-flag",
        //   to: "https://github.com/vuetifyjs/vuetify/releases/latest",
        // },
      ],
    };
  },
  props: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
